import { createRoute } from '@tanstack/react-router'
import { lawyerRoute } from '../index'
import { LawyerCaseDetail } from '@/components/lawyer/LawyerCaseDetail'

function CaseDetailPage() {
  const { caseId } = lawyerCaseDetailRoute.useParams()
  return <LawyerCaseDetail caseId={parseInt(caseId, 10)} />
}

export const lawyerCaseDetailRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/cases/$caseId',
  component: CaseDetailPage,
})
